// ========================================
// PAGE AdminPortal
// Première porte de sécurité
// ========================================

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FiLock, FiArrowRight, FiShield } from 'react-icons/fi';
import '../../styles/admin.css';

const AdminPortal = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    // Vérifier le mot de passe du portail
    const portalPassword = process.env.REACT_APP_PORTAL_PASSWORD;

    // Simuler un délai pour la sécurité
    setTimeout(() => {
      if (password === portalPassword) {
        // Stocker un token temporaire pour accéder à la page de login
        sessionStorage.setItem('portalAccess', 'granted');
        sessionStorage.setItem('portalTimestamp', Date.now().toString());
        toast.success('Accès autorisé !');
        navigate('/admin-login');
      } else {
        setError('Mot de passe incorrect');
        toast.error('Accès refusé');
      }
      setIsLoading(false);
    }, 800);
  };

  return (
    <div className="portal-gate">
      <div className="portal-card">
        <div className="portal-icon">
          <FiShield />
        </div>
        
        <h1>Accès Restreint</h1>
        <p>Cette zone est réservée à l'administrateur du site</p>

        <form onSubmit={handleSubmit}>
          {error && (
            <div className="login-error">
              <FiLock style={{ marginRight: '0.5rem' }} />
              {error}
            </div>
          )}
          
          <div className="form-group">
            <label className="form-label" htmlFor="password">
              Mot de passe d'accès
            </label>
            <div className="input-with-icon">
              <FiLock className="input-icon" />
              <input
                type="password"
                id="password"
                className="form-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••••"
                required
                autoFocus
                autoComplete="off"
              />
            </div>
          </div>

          <button 
            type="submit" 
            className="btn btn-primary btn-block"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="btn-spinner"></span>
                Vérification...
              </>
            ) : (
              <>
                Accéder
                <FiArrowRight />
              </>
            )}
          </button>
        </form>
      </div>

      <style>{`
        .portal-icon {
          width: 80px;
          height: 80px;
          background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-dark) 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto var(--spacing-6);
        }
        
        .portal-icon svg {
          font-size: 2.5rem;
          color: white;
        }
        
        .input-with-icon {
          position: relative;
        }
        
        .input-icon {
          position: absolute;
          left: 1rem;
          top: 50%;
          transform: translateY(-50%);
          color: var(--color-gray-400);
        }
        
        .input-with-icon .form-input {
          padding-left: 3rem;
        }
        
        .btn-block {
          width: 100%;
          margin-top: var(--spacing-4);
        }
        
        .btn-spinner {
          width: 18px;
          height: 18px;
          border: 2px solid rgba(255,255,255,0.3);
          border-top-color: white;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
          margin-right: 0.5rem;
        }
      `}</style>
    </div>
  );
};

export default AdminPortal;